import { ListGroup } from "react-bootstrap";
import { EnvelopeFill, EnvelopeOpen } from "react-bootstrap-icons";

interface NotificationListItemEnvelopeProps {
  id: number;
  viewed: boolean;
  toggleNotificationStatus: (notificationId: number) => void;
}

/**
 * Envelope toggle control for a notification list item.
 *
 * @param props - Destructured parameter object
 * @param props.id - Notification id used for DOM attributes
 * @param props.viewed - Whether the notification is already viewed
 * @param props.toggleNotificationStatus - Callback to toggle the notification's viewed state
 */
export const NotificationListItemEnvelope = ({
  id,
  viewed,
  toggleNotificationStatus,
}: NotificationListItemEnvelopeProps): React.ReactElement => (
  <ListGroup.Item
    key={`${id}-toggle`}
    id={`notification-${id}-toggle`}
    className="d-flex align-items-center"
    style={{ cursor: "pointer" }}
    title={`Mark as ${viewed ? "unread" : "read"}`}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleNotificationStatus(id);
    }}
  >
    {viewed ? <EnvelopeOpen size="20" /> : <EnvelopeFill size="20" />}
  </ListGroup.Item>
);

NotificationListItemEnvelope.displayName = "NotificationListItemEnvelope";
